export const TakeoverPosition = {
	BOTTOM_LEFT:  'bottom_left',
	BOTTOM_RIGHT: 'bottom_right',
	TOP_LEFT:     'top_left',
	TOP_RIGHT:    'top_right',
};
